import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import * as Masonry from "masonry-layout";
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

import { ResourceService } from '../../../services/resource.service';
import { Resource } from '../../../models/resource';
import { ResourceType } from '../../../models/resource';
import { Content } from '../../../models/content';

@Component({
  selector: 'app-background',
  templateUrl: './background.component.html',
  styleUrls: ['./background.component.scss']
})
export class BackgroundComponent implements OnInit {

  @Input()
  private content: Content;

  @Input()
  primaryColor: string;
  @Input()
  secondaryColor: string;

  @Input() private startingPage: number;
  @Output() private saveStartingPage = new EventEmitter<number>();

  @Output() resourceClick = new EventEmitter<Resource>();
  @Output() private userForbidden = new EventEmitter<boolean>();

  resourceJSON: JSON;
  type : number;

  paginationEnabled = [false,false]; // [is prev-page btn enabled, is next-page btn enabled]

  masonryGrid: Masonry;
  mainLoading: Boolean;

  inputSearch: string;

  constructor(private resourceService: ResourceService, private _sanitizer: DomSanitizer) {
    this.inputSearch = null;
  }

  ngOnInit() {
    this.type = 1;
    this.resourceJSON = JSON.parse("{}");
    this.resourceJSON['pgno'] = this.startingPage;
    this.resourceJSON['pgcount'] = 12;
    this.resourceJSON['loading'] = true;
    this.mainLoading = true;
    this.getPaginationInfo(true);
    this.inputSearch = '';
  }

  getPaginationInfo(flag: boolean): void{
    var self = this;
    this.mainLoading = true;
    this.resourceService.getResourcesPaginationInfo(this.type, this.content, this.inputSearch)
    .then(
      count => {
        self.resourceJSON['count'] = count;
        this.mainLoading = false;
        if(flag){
          this.getResourcesForPage();
        }
      },
      err => {
        if(err.status == 403){
          this.userForbidden.emit(true);
        }
        console.log(err)
      }
    );
  }

  getResourcesForPage(): void{
    var self = this;
    this.mainLoading = true;
    this.resourceService.getResourcesForPage(this.resourceJSON['pgno'], this.resourceJSON['pgcount'], this.type, this.content, this.inputSearch)
    .then(
      resources => {
        self.resourceJSON['resources'] = resources;
        self.resourceJSON['loading'] = false;
        self.mainLoading = false;
        for(var i in resources){
          self.getPreviewImage(resources[i]);
        }
      },
      err => {
        if(err.status == 403){
          this.userForbidden.emit(true);
        }
        console.log(err)
      }
    );
    let testVals = [
      ((this.resourceJSON['pgno']-1)*this.resourceJSON['pgcount'])/this.resourceJSON['count'],
      ((this.resourceJSON['pgno'])*this.resourceJSON['pgcount'])/this.resourceJSON['count']
    ];
    this.paginationEnabled[0] = (testVals[0] > 0 && testVals[0] <= 1) ? true : false;
    this.paginationEnabled[1] = (testVals[1] > 0 && testVals[1] <= 1) ? true : false;
  }

  getPreviewImage(resource: Resource): any{
    var self = this;
    if(resource.mainPreview){
      return resource.mainPreview;
    } else{
      this.resourceService.getResourceThumbPreview(resource)
      .subscribe((res) => {
        //resource.imageData = res;
        resource.thumbPreview = self._sanitizer.bypassSecurityTrustResourceUrl(res); 
        //resource.mainPreview = self._sanitizer.bypassSecurityTrustResourceUrl(res);
      });
    }
    return true;
  }

  backgroundSelected(resource: Resource): void{
    this.resourceClick.emit(resource);
    this.saveStartingPage.emit(this.resourceJSON['pgno']);
  }

  changePage(n: number){
    if(this.paginationEnabled[n+1]){
      this.resourceJSON['pgno'] += n==0 ? 1 : -1;
      this.getResourcesForPage();
    }
  }

  onSearch(){
    this.resourceJSON['pgno'] = 1;
   this.getPaginationInfo(true);
  }

  initMasonry(){
    this.masonryGrid = new Masonry('.masonry-grid',{
      itemSelector : '.masonry-grid-item',
      columnWidth : '.masonry-grid-sizer',
      percentPosition : true,
      horizontalOrder : true,
      gutter: '.masonry-gutter-sizer',
      transitionDuration: '0.35s'
    });
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(){
    this.initMasonry();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/gallery/background/background.component.ts